export const getSelectedSalesSpaceChannelsInGroupSort = (state) =>
  state.salesSpaceChannels.selectedSalesSpaceChannelsInGroupSort;
